<template>
	<div v-if="wrap" class="text-center loading">
		<i :class="`fa fa-circle-o-notch fa-spin ${iconClass}`"></i>
	</div>
	<i v-else :class="`fa fa-circle-o-notch fa-spin ${iconClass}`" />
</template>

<script>
export default {
	props: {
		iconClass: {
			type: String,
			required: false,
			default: '',
		},
		wrap: {
			type: Boolean,
			required: false,
			default: true,
		},
	}
}
</script>
